const n = `  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" id="mxp-icon-circle-star"\r
    xmlns="http://www.w3.org/2000/svg"\r
    xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 48 48" style="enable-background:new 0 0 48 48;" xml:space="preserve">\r
    <g>\r
      <path d="M24,2.08C11.92,2.08,2.08,11.92,2.08,24c0,12.08,9.84,21.92,21.92,21.92S45.92,36.08,45.92,24\r
    C45.92,11.92,36.08,2.08,24,2.08z M24,43.92C13.02,43.92,4.08,34.98,4.08,24C4.08,13.02,13.02,4.08,24,4.08S43.92,13.02,43.92,24\r
    C43.92,34.98,34.98,43.92,24,43.92z"/>\r
      <path d="M38.2314,19.6416c-0.2305-0.7129-0.8906-1.1914-1.6416-1.1914h-8.3574l-2.5859-7.9648\r
    C25.4014,9.7715,24.7549,9.3101,24,9.3101s-1.4009,0.4614-1.6514,1.1914l-2.5806,7.9487h-8.3579\r
    c-0.7515,0-1.4111,0.4785-1.6421,1.1914c-0.2339,0.7222,0.0156,1.479,0.6343,1.9272l6.7554,4.9106l-2.5757,7.9531\r
    c-0.1772,0.5303-0.0957,1.0898,0.2241,1.5342c0.5405,0.751,1.6748,0.9434,2.4326,0.4014l6.7607-4.9248l6.7681,4.9297\r
    c0.2949,0.2109,0.6318,0.3174,1.002,0.3174c0.5654,0,1.0967-0.2705,1.4238-0.7227c0.3193-0.4443,0.4023-1.0039,0.2275-1.5264\r
    l-2.5791-7.9619l6.7539-4.9097C38.2168,21.1206,38.4658,20.3638,38.2314,19.6416z M29.5059,24.978\r
    c-0.5928,0.4263-0.8477,1.1938-0.627,1.9302l2.3799,7.3477l-6.2612-4.5596C24.7109,29.498,24.3564,29.3896,24,29.3896\r
    s-0.7109,0.1084-1.019,0.3213l-6.2397,4.5449l2.3867-7.3691c0.2144-0.7148-0.0405-1.4824-0.6299-1.9058l-6.2329-4.5308h7.7046\r
    c0.7539,0,1.4316-0.5024,1.6416-1.2017L24,11.8916l2.3818,7.335c0.2158,0.7202,0.8936,1.2236,1.6484,1.2236h7.7051L29.5059,24.978z\r
    "/>\r
    </g>\r
  </svg>\r`;
export {
  n as default
};
